module.exports = __webpack_public_path__ + "media/images/landing-91680d747e99764efb52b951b44f58c1.png";